/**
 * Wishlist BOGO (Buy One Get One) Script - SMART TAG VERSION
 * Automatically adds 2 units to the cart if a product has the tag 'BOGO'.
 */

(function() {
    const CONFIG = {
        addToCartSelector: '.wishlist-hero-list-card-footer-add-to-cart',
        cardSelector: '.wishlist-hero-list-card',
        bogoTag: 'BOGO', // The tag to look for in Shopify
        quantity: 2,
        redirectAfterAdd: true,
        cartUrl: '/cart'
    };

    function init() {
        

        document.addEventListener('click', function(event) {
            const btn = event.target.closest(CONFIG.addToCartSelector);
            if (!btn) return;

            const card = btn.closest(CONFIG.cardSelector);
            if (!card) return;

            // Prevent default immediately to check tags first
            event.preventDefault();
            event.stopImmediatePropagation();

            handleAddToCart(card, btn);
        }, true);
    }

    async function handleAddToCart(card, btn) {
        const originalText = btn.innerText;
        btn.innerText = 'CHECKING...';
        btn.disabled = true;

        try {
            // 1. Get product handle from the URL
            const productLink = card.querySelector('a[href*="/products/"]');
            if (!productLink) throw new Error('Product link not found');

            const urlPath = new URL(productLink.href).pathname;
            const handle = urlPath.split('/').pop().split('?')[0];

            // 2. Fetch product data from Shopify AJAX API to check tags
            const response = await fetch(`/products/${handle}.js`);
            const productData = await response.json();

            // 3. Check if 'BOGO' tag exists
            const isBogo = productData.tags.some(tag => tag.toUpperCase() === CONFIG.bogoTag);

            const variantId = getVariantId(card) || productData.variants[0].id;

            if (isBogo) {
                
                addToCart(variantId, CONFIG.quantity, btn, originalText);
            } else {
                
                addToCart(variantId, 1, btn, originalText);
            }

        } catch (error) {
            console.error('Wishlist BOGO Error:', error);
            btn.innerText = 'ERROR';
            setTimeout(() => { btn.innerText = originalText; btn.disabled = false; }, 2000);
        }
    }

    function getVariantId(card) {
        const priceDiv = card.querySelector('[id^="wishlist-hero-price-update-"]');
        if (priceDiv) return priceDiv.id.replace('wishlist-hero-price-update-', '');
        
        const link = card.querySelector('a[href*="variant="]');
        if (link) {
            const match = link.href.match(/variant=(\d+)/);
            return match ? match[1] : null;
        }
        return null;
    }

    function addToCart(variantId, quantity, btn, originalText) {
        btn.innerText = quantity > 1 ? 'ADDING PAIR...' : 'ADDING...';

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
        })
        .then(res => res.json())
        .then(data => {
            if (CONFIG.redirectAfterAdd) {
                window.location.href = CONFIG.cartUrl;
            } else {
                btn.innerText = 'ADDED!';
                setTimeout(() => { btn.innerText = originalText; btn.disabled = false; }, 2000);
            }
        })
        .catch(err => {
            console.error('Cart Add Error:', err);
            btn.innerText = 'ERROR';
            setTimeout(() => { btn.innerText = originalText; btn.disabled = false; }, 2000);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
